import { createFileRoute } from '@tanstack/react-router';
import { devicesQuery } from '@/features/devices/api';
import { MonitoringDevicesPage } from '@/features/devices/monitoring/MonitoringDevicesPage';

/** "Qurilma ma'lumoti" — data monitoring (583:14817). */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/monitoring/devices')({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(devicesQuery(context.tenant.id));
  },
  component: MonitoringDevicesRoute,
});

function MonitoringDevicesRoute() {
  const { tenant } = Route.useRouteContext();
  return <MonitoringDevicesPage tenant={tenant} />;
}
